import { ExpandMore as ExpandMoreIcon } from '@tunasong/icons'
import type { TunaPluginRenderContextProps } from '@tunasong/plugin-lib'
import { Accordion, AccordionDetails, AccordionSummary, Typography, type AccordionProps } from '@tunasong/ui-lib'
import type { FC } from 'react'
import React, { useState } from 'react'

export interface PanelProps extends Omit<AccordionProps, 'children'>, Partial<TunaPluginRenderContextProps> {
  className?: string
  title?: string
  subtitle?: string
  gutters?: boolean
  children?: React.ReactNode
}

const Panel: FC<PanelProps> = props => {
  const { className, gutters = true, title = 'Unknown', subtitle, defaultExpanded = true, children } = props
  const [expanded, setExpanded] = useState(defaultExpanded)
  const handleExpand = (_ev: unknown, expanded: boolean) => setExpanded(expanded)

  return (
    <Accordion className={className} expanded={expanded} onChange={handleExpand}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography
          style={{
            fontSize: '0.9375rem',
            flexBasis: '33.33%',
            flexShrink: 0,
            flex: 1,
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            style={{
              fontSize: '0.9375rem',
            }}
            color="text.secondary"
          >
            {subtitle}
          </Typography>
        ) : null}
      </AccordionSummary>

      <AccordionDetails
        style={{
          padding: gutters ? '8px 16px 0 16px' : '8px 0 0 0',
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

export default Panel
